import email from './Email.js'
import domain from './Domain.js'
import avatar from './Avatar.js'
import { LocaleInternet } from '../../Types.js'

const internet: LocaleInternet = {
  email,
  domain,
  avatar,
}

export default internet
